module.exports = __webpack_public_path__ + "img/power-level-1.aa08c0a4.png";